import { useEnrollmentsByIds } from '@actions';
import { ReactComponent as BackSignIcon } from '@assets/icons/back-sign.svg';
import Button from '@components/V4/Button';
import Modal from '@components/V4/Modal/Modal';
import { PaginationProps } from '@components/V4/Pagination';
import { useState } from 'react';
import EnrollmentsListSection from './EnrollmentsListSection/EnrollmentsListSection';

interface EnrollmentsDetailsPageProps {
  enrollmentsIds: string[];
  isBackButtonActive?: boolean;
  onGoBack?: () => void;
  onMentorModalOpen: (id: string) => void;
  onStudentModalOpen: (id: string) => void;
  onEnrollmentModalOpen: (id: string) => void;
}

const EnrollmentsDetailsPage = (props: EnrollmentsDetailsPageProps) => {
  const {
    enrollmentsIds,
    isBackButtonActive = false,
    onMentorModalOpen,
    onStudentModalOpen,
    onEnrollmentModalOpen,
    onGoBack,
  } = props;
  const [page, setPage] = useState<number | null>(null);
  const [limit, setLimit] = useState<number | null>(null);

  const { data, isLoading: areEnrollmentsLoading } = useEnrollmentsByIds(
    {
      page: page ?? 1,
      limit: limit ?? 10,
      enrollmentsIds: enrollmentsIds.join(','),
    },
    {
      enabled: enrollmentsIds.length > 0,
    }
  );

  const currentPageChangeHandler = (page: number) => {
    setPage(page);
  };

  const pageSizeChangeHandler = (pageSize: number) => {
    setLimit(pageSize);
  };

  const pagination: PaginationProps = {
    pageSize: limit !== null ? limit : 10,
    total: data?.total ?? 0,
    currentPage: page !== null ? page : 1,
    onCurrentPageChange: currentPageChangeHandler,
    onPageSizeChange: pageSizeChangeHandler,
  };

  return (
    <>
      <Modal.Header className="relative font-raleway text-xl font-bold text-center mb-6">
        {isBackButtonActive && (
          <Button
            icon={<BackSignIcon />}
            className="absolute top-0 left-6"
            variant="secondary"
            onClick={onGoBack}
            buttonText="Back"
          />
        )}
        <h3>Bulk Edit Enrollments</h3>
      </Modal.Header>
      <Modal.Body>
        <section className="flex flex-col gap-6">
          <EnrollmentsListSection
            enrollments={data?.enrollments ?? []}
            pagination={pagination}
            areEnrollmentsLoading={areEnrollmentsLoading}
            onMentorModalOpen={onMentorModalOpen}
            onStudentModalOpen={onStudentModalOpen}
            onEnrollmentModalOpen={onEnrollmentModalOpen}
            allEnrollmentsIds={enrollmentsIds}
          />
        </section>
      </Modal.Body>
    </>
  );
};

export default EnrollmentsDetailsPage;
